do ->
  hasCqh = CSS?.supports?('font-size', '1cqh')
  hasCqw = CSS?.supports?('font-size', '1cqw')

  if not (hasCqh or hasCqw)
  # if (hasCqh or hasCqw)
    $.ajax(
      dataType: 'JSON'
      method: 'POST'
      url: '/ajax/app/cq_log/'
      data:
        app_url: window.location.pathname
        user_agent: navigator.userAgent
    ).done (check) ->
      console.log check